var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all-servers-table-container"},[_c('sidebar',{staticClass:"all-servers-table-container__sidebar",attrs:{"sidebar-dashboard":true}}),_c('creator-name',{staticClass:"all-servers-table-container__creator-name"}),_c('div',{staticClass:"all-servers-table-container__summary-table"},[_c('div',{staticClass:"return"},[_c('button-back',{staticClass:"return__button-return"})],1),_c('div',{staticClass:"summary-data-table__title"},[_vm._v("Summary")]),_c('div',{staticClass:"all-data-server-table"},[_c('Table',{attrs:{"columns":[
                    'Type',
                    'Provider',
                    'Game name',
                    'Players',
                    'Peak (24)',
                    'Expiration',
                    'Running time',
                ],"data":_vm.filteredServers && _vm.filteredServers.length > 0
                        ? _vm.filteredServers
                        : null,"cell-style":'display: grid; grid-template-columns: 2fr 2fr 3fr 2fr 2fr 2fr 2fr; grid-template-rows: 4rem;',"data-elements":[
                    'type',
                    'provider',
                    'gameName',
                    'players',
                    'peak',
                    'expiration',
                    'runningTime',
                ],"is-loading":_vm.getLoading,"no-title":true}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }